const updateQty = () => {
  const updateTotal = (e = null) => {
    if (e) e.preventDefault();
    const qtyElements = document.querySelectorAll('.qty');
    const priceElements = document.querySelectorAll('.price');

    if (!qtyElements || !priceElements) return;

    let total = 0;
    qtyElements.forEach((qtyElement, index) => {
      if (qtyElement.value < 1) {
        console.log(qtyElement);
        qtyElement.value = 1;
      }
      if (!priceElements[index]) return;
      if  (priceElements.length > 0) {
        total += parseInt(qtyElement.value) * parseFloat(priceElements[index].innerHTML, 2);
      }
    });

    const sousTotal = document.querySelector('.sous-total');
    const frais = document.querySelector('.frais');
    const ttc = document.querySelector('.ttc');
    const remain = document.querySelector('.remain');

    if (sousTotal && frais && ttc) {
      sousTotal.textContent = total.toFixed(2);
      frais.textContent = (total < 50) ? '5.80€' : 'Offerts';
      ttc.textContent = (total < 50) ? (total + 5.8).toFixed(2) : total.toFixed(2);
      remain.textContent = (total < 50) ? (50 - total).toFixed(2) : '0.00';
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    updateQty(e.target.innerHTML, e.target.parentNode);
  };

  const init = () => {
    const plusElements = document.querySelectorAll('.plus');
    const qtyElements = document.querySelectorAll('.qty');
    const minusElements = document.querySelectorAll('.minus');

    if (plusElements && minusElements && qtyElements) {
      plusElements.forEach(current => current.addEventListener('click', updateTotal));
      qtyElements.forEach(current => current.addEventListener('change', updateTotal));
      minusElements.forEach(current => current.addEventListener('click', updateTotal));
    }
  };

  init();
  updateTotal();
};

export default updateQty;
